import React, { useState } from 'react';
import { Form, Button, Input, Toast, Space } from '@douyinfe/semi-ui';
import request from '../../utils/request';
import styles from '../Login/index.module.scss';
import { siteConfig } from '../../config';

const Register = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const handleSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      Toast.error('两次输入的密码不一致');
      return;
    }

    setLoading(true);
    try {
      const response = await request.post('/go/common/register/', {
        account: values.username,
        passwd: values.password,
        code: '',
        name: values.displayName || values.username,
        channel: values.channel || ''
      });

      if (response.errno === 0) {
        Toast.success('注册成功');
        // 保存登录状态和用户信息
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('user', JSON.stringify({ username: values.username }));
        localStorage.setItem('token', response.token);
        setLoading(false);
        if (onLogin) {
          onLogin();
        }
      } else {
        Toast.error(response.errstr || '注册失败');
        setLoading(false);
      }
    } catch (error) {
      console.error('注册失败:', error);
      Toast.error('注册失败，请检查网络连接');
      setLoading(false);
    }
  };

  if (showLogin) {
    window.location.reload();
    return null;
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <div className={styles.loginHeader}>
          <img src={siteConfig.site.logo} alt={siteConfig.site.shortName} className={styles.logo} />
          <h2>{siteConfig.site.title}</h2>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            field="username"
            label="手机号码"
            placeholder="请输入登录用手机号码"
            rules={[{
              required: true,
              message: '请输入登录用手机号码',
              validator: (rule, value) => {
                return /^\w{3,16}$/.test(value);
              },
              message: '请输入有效的手机号码'
            }]}
          />
          <Form.Input
            field="password"
            label="密码"
            type="password"
            placeholder="请输入密码（至少6位）"
            rules={[{
              required: true,
              message: '请输入密码',
              validator: (rule, value) => {
                return value && value.length >= 6;
              },
              message: '密码长度不能少于6位'
            }]}
          />
          <Form.Input
            field="confirmPassword"
            label="确认密码"
            type="password"
            placeholder="请再次输入密码"
            rules={[{ required: true, message: '请再次输入密码' }]}
          />
          <Form.Input
            field="displayName"
            label="公司名称/姓名"
            placeholder="请输入公司或个人名称"
            rules={[{
              required: true,
              message: '请输入用户名',
              validator: (rule, value) => {
                return value && value.length <= 16 && /^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(value);
              },
              message: '用户名必须为16位以内的中英文字符'
            }]}
          />
          <Form.Input
            field="channel"
            label="推荐人"
            placeholder="请输入推荐人（选填）"
          />
          <Space vertical align="start" spacing="loose" style={{ width: '100%' }}>
            <Button
              theme="solid"
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              className={styles.loginButton}
            >
              注册
            </Button>
            <Button
              theme="light"
              type="primary"
              block
              onClick={() => setShowLogin(true)}
            >
              返回登录
            </Button>
          </Space>
        </Form>
      </div>
    </div>
  );
};

export default Register;